import { FRENCH_PHONE_NUMBER_REGEX } from '../../components/Form/validationSchema';

export const formatNumberWithThousandsSeparator = (value: number) =>
  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatStringNumberToPhoneNumberWithSpaces = (phoneNumberWithoutSpace: string) => {
  if (!phoneNumberWithoutSpace.match(FRENCH_PHONE_NUMBER_REGEX)) {
    return phoneNumberWithoutSpace;
  }

  if (phoneNumberWithoutSpace.includes('+33')) {
    return `${phoneNumberWithoutSpace.slice(0, 4)} ${phoneNumberWithoutSpace.slice(
      4,
      6,
    )} ${phoneNumberWithoutSpace.slice(6, 8)} ${phoneNumberWithoutSpace.slice(
      8,
      10,
    )} ${phoneNumberWithoutSpace.slice(10, 12)}`;
  }
  return phoneNumberWithoutSpace.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
};

// Auto-formats a raw phone input into the `111-111-1111` pattern as the user types.
// Strips non-digits, caps at 10 digits, and inserts dashes after the 3rd and 6th digit.
export const formatPhoneNumberInput = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) {
    return digits;
  }
  if (digits.length <= 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const formatAmountWithSeparators = (value: number | string) =>
  Number(String(value).trim()).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
